import { Card, Statistic } from "antd";

export const weddingDate = new Date('09/08/2026');

const Countdown = () => {
    return (
        <Card style={{ width: 'fit-content' }}>
            <Statistic.Timer title='Countdown to Our Wedding' type='countdown' value={weddingDate.toDateString()} format='DD HH:mm:ss' />
        </Card>
    );
};

export default Countdown;